"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceZoneStats_1 = require("../model/PriceZoneStats");

var PriceZoneStatsConverter_1 = require("./PriceZoneStatsConverter");
/**
 * Default implementation of {@link PriceZoneStatsConverter}.
 *
 * @author Radek Beran
 */


var PriceZoneStatsConverterImpl =
/*#__PURE__*/
function (_PriceZoneStatsConver) {
  _inherits(PriceZoneStatsConverterImpl, _PriceZoneStatsConver);

  function PriceZoneStatsConverterImpl() {
    _classCallCheck(this, PriceZoneStatsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneStatsConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(PriceZoneStatsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceZoneStats_1.PriceZoneStats(PriceZoneStats_1.PriceZoneStats.schema.priceZoneId.valueOfField(source), PriceZoneStats_1.PriceZoneStats.schema.sitesCount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, {
        priceZoneId: source.priceZoneId,
        sitesCount: source.sitesCount
      });
      return document;
    }
  }]);

  return PriceZoneStatsConverterImpl;
}(PriceZoneStatsConverter_1.PriceZoneStatsConverter);

exports.PriceZoneStatsConverterImpl = PriceZoneStatsConverterImpl;